import script from "./StoryImage.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryImage.vue?vue&type=script&lang=js"
export * from "./StoryImage.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/story-page/StoryImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a22194f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a22194f2', __exports__)) {
    api.reload('a22194f2', __exports__)
  }
  
}


export default __exports__